import{useLayoutEffect as n}from"react";var o=function(o,t){n((function(){"undefined"!=typeof window&&o()}),[t])};export{o as default,o as useLayoutEffectBrowser};
//# sourceMappingURL=useLayoutEffectBrowser.js.map
